module.exports = __webpack_public_path__ + "img/hanyue_pink.8913a7c2.png";